import { render, staticRenderFns } from "./BuildingView.vue?vue&type=template&id=a6a72814&"
import script from "./BuildingView.vue?vue&type=script&lang=js&"
export * from "./BuildingView.vue?vue&type=script&lang=js&"
import style0 from "./BuildingView.vue?vue&type=style&index=0&id=a6a72814&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports